var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ]
    },
    [
      _c("el-header", [
        _c("ul", { staticClass: "List-headr" }, [
          _c(
            "li",
            [
              _vm.addPower
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        icon: "el-icon-plus",
                        size: "small"
                      },
                      on: {
                        click: function($event) {
                          return _vm.setAddAndModify(false)
                        }
                      }
                    },
                    [_vm._v("新建投放单元")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSspUser
            ? _c(
                "li",
                [
                  _c("span", [_vm._v("所属广告主：")]),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      attrs: { size: "small" },
                      on: {
                        change: function($event) {
                          _vm.myOption.restStartPage()
                          _vm.setUserId()
                        }
                      },
                      model: {
                        value: _vm.queryUser,
                        callback: function($$v) {
                          _vm.queryUser = $$v
                        },
                        expression: "queryUser"
                      }
                    },
                    _vm._l(_vm.userData, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.advertiserName,
                          value: item.advertiserId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("投放单元名称：")]),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  size: "small",
                  placeholder: "请输入内容",
                  "prefix-icon": "el-icon-search"
                },
                on: { input: _vm.getList },
                model: {
                  value: _vm.queryUnitName,
                  callback: function($$v) {
                    _vm.queryUnitName = $$v
                  },
                  expression: "queryUnitName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("状态：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { size: "small" },
                  on: {
                    change: function($event) {
                      _vm.myOption.restStartPage()
                      _vm.getList()
                    }
                  },
                  model: {
                    value: _vm.queryStatus,
                    callback: function($$v) {
                      _vm.queryStatus = $$v
                    },
                    expression: "queryStatus"
                  }
                },
                _vm._l(_vm.myOption.status, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            [
              _c("span", [_vm._v("投放计划：")]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { size: "small" },
                  on: {
                    change: function($event) {
                      _vm.myOption.restStartPage()
                      _vm.getList()
                    }
                  },
                  model: {
                    value: _vm.queryPlan,
                    callback: function($$v) {
                      _vm.queryPlan = $$v
                    },
                    expression: "queryPlan"
                  }
                },
                _vm._l(_vm.planData, function(item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.planName, value: item.planId }
                  })
                }),
                1
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "ListMain" },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, height: "100%" } },
            [
              _c("el-table-column", {
                attrs: { type: "expand" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "el-form",
                          {
                            staticClass: "ListMain-table-expand",
                            attrs: { "label-position": "left", inline: "" }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "创建时间" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(props.row.createTime))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "最后修改时间" } },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(props.row.updateTime))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-form-item", { attrs: { label: "修改人" } }, [
                              _c("span", [_vm._v(_vm._s(props.row.modifier))])
                            ]),
                            _vm._v(" "),
                            _c("el-form-item", { attrs: { label: "备注" } }, [
                              _c("span", [_vm._v(_vm._s(props.row.remark))])
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "putUnitId", label: "ID", "min-width": "100px" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "putUnitName",
                  label: "投放单元名称",
                  "min-width": "200px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "slotType",
                  label: "代码位类型",
                  "min-width": "150px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "assignSlot",
                  label: "代码位定向",
                  "min-width": "200px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "planInfoVo.planName",
                  label: "投放计划名称",
                  "min-width": "150px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "flowTypeText",
                  label: "流量类型",
                  "min-width": "150px"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "创意统计", "min-width": "150px" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return _vm.ideaPower
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.jumpUnit(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.ideaNum))]
                            )
                          : _c("span", [_vm._v(_vm._s(scope.row.ideaNum))])
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              _vm.addPower || _vm.deletePower || _vm.modifyPower
                ? _c("el-table-column", {
                    attrs: { "min-width": "150px" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function(scope) {
                            return [
                              _vm._v("\n          操作\n          "),
                              _c("i", {
                                staticClass: "el-icon-question",
                                attrs: { title: "创意统计 >0 时，禁用删除操作" }
                              })
                            ]
                          }
                        },
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.addPower
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#67C23A" },
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setAddAndModify(
                                            _vm.tableData[scope.$index],
                                            true
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("复制")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.modifyPower
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setAddAndModify(
                                            _vm.tableData[scope.$index]
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("修改")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.deletePower &&
                              _vm.tableData[scope.$index].ideaNum === 0
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { color: "#F56C6C" },
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setDelete(
                                            _vm.tableData[scope.$index]
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      667273113
                    )
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-footer",
        [_c("Pagination", { attrs: { getList: _vm.getList } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44875a09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44875a09","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unit/List.vue
// module id = fOzI
// module chunks = 1